import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=0ae61fea&scoped=true&"
import script from "./orderInformation.vue?vue&type=script&lang=js&"
export * from "./orderInformation.vue?vue&type=script&lang=js&"
import style0 from "./orderInformation.vue?vue&type=style&index=0&id=0ae61fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae61fea",
  null
  
)

export default component.exports